/**
 * Gravitas Medspa online shop listings from https://www.gravitasmedspa.com/products-list
 * (photos + product detail links on gravitasmedspa.com).
 */
export interface GravitasShopListing {
  shopName: string;
  price: number;
  productUrl: string;
  imageUrl: string;
}

export const GRAVITAS_SHOP_LISTINGS: GravitasShopListing[] = [
  {
    shopName: "Acne Basic Essentials",
    price: 270,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b907c0e82043e54a2c87a",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35b1b5323a0a7aa3a9.webp",
  },
  {
    shopName: "Acne Benzoyl Wash",
    price: 58,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b5ea1e1ea43a92b61b86b",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5e6717ca127d98d44583.webp",
  },
  {
    shopName: "Acne Cream",
    price: 68,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b60abe1ea4383e261b927",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35b1b53236ba7aa3b3.webp",
  },
  {
    shopName: "Acne Erase",
    price: 50,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65cb489abb3d525a7c1e939f",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65caa69797fb7b7bb81bd795.png",
  },
  {
    shopName: "Active Moisturizer",
    price: 68,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b828b0e82041d9ea2c18a",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8e5a69844c00.webp",
  },
  {
    shopName: "Balancing Toner",
    price: 38,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b83fde1ea43107061ccbd",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35e5ff81b2e601751e.webp",
  },
  {
    shopName: "Beauty oil",
    price: 120,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b845d0e8204ead0a2c228",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35097342666df57e51.webp",
  },
  {
    shopName: "Beauty Queen Skincare Kit",
    price: 380,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b84ace1ea43906d61cd1e",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3573d3b06c714a928c.webp",
  },
  {
    shopName: "Biome Balance",
    price: 85,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/biomebalance",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65caa697fdc0067ad75434ae.png",
  },
  {
    shopName: "Blemish Corrector",
    price: 120,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/6632abb78f23262e31794cef",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/6632ab88d778757a22b9b233.png",
  },
  {
    shopName: "Body BB Glow",
    price: 95,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b90380e82041884a2c86d",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f355dbca51630c0bae5.webp",
  },
  {
    shopName: "Broad Spectrum Sunscreen",
    price: 68,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b88560e82047f3ea2c399",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3509734200a8f57e52.webp",
  },
  {
    shopName: "Cell Repair (Growth Factor)",
    price: 145,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65cb4501bb3d5277431e92f3",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65caa69743c7e922dc3e3820.png",
  },
  {
    shopName: "Cleansing Milk",
    price: 38,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9b53e1ea43b44361d619",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f355dbca54bbec0bae7.webp",
  },
  {
    shopName: "Complete Acne Solution",
    price: 458,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666ba07be1ea43a4de61d803",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f353ae33391bc59a091.webp",
  },
  {
    shopName: "Daily Essential Travel Set",
    price: 95,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b97e6e1ea43539b61d524",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f355dbca592a3c0bae6.webp",
  },
  {
    shopName: "Daily Essentials Regimen",
    price: 212,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9ac60e8204e648a2cbb4",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35189fdd3a7b97373b.webp",
  },
  {
    shopName: "Fresh Look Eye Repair Cream",
    price: 85,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65cb480118faaa6b7f36b986",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65caa6970ac0a26b734e082b.png",
  },
  {
    shopName: "Glass Skin Serum",
    price: 95,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/67338e2fbc5a0a5327d64c8a",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/67338cd4a85019753306a7a9.jpeg",
  },
  {
    shopName: "Glow N Go Kit",
    price: 229,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/glowngokit",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/67c212b8452e08f642ae0cd6.png",
  },
  {
    shopName: "Gluta ProX",
    price: 99.5,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b87ba0e82044924a2c36c",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8e76c1844bfc.webp",
  },
  {
    shopName: "Healthy Hair Conditioner",
    price: 25,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b87190e8204a386a2c2fa",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35b1b53205427aa3b2.webp",
  },
  {
    shopName: "Healthy Hair Shampoo",
    price: 25,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b86bce1ea43664061cdd6",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3573d3b0183e4a928b.webp",
  },
  {
    shopName: "Hydrating Gel",
    price: 68,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b85e1e1ea43c86561cd8a",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8e437f844bfd.webp",
  },
  {
    shopName: "Luminous Oil Cleanser",
    price: 34,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/luminous-oil-cleanser",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/66b0ecca2b4a6a5430b811ef.png",
  },
  {
    shopName: "Milk Brigthening Bar",
    price: 20,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9f9be1ea435a2e61d7de",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b9f6e5212647634253dbf.webp",
  },
  {
    shopName: "Oil Control Cleanser",
    price: 47,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/oilcontrolcleanser",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/66d8dc3fab806e8053327a81.jpeg",
  },
  {
    shopName: "Oil Control Toner",
    price: 36,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/6632ad218f232642df794db5",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/6632acebd77875acc4b9b37d.png",
  },
  {
    shopName: "OLIVIA NO.1 EAU DE PARFUM",
    price: 120,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/67a10242307b5b673c921f59",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/67a101ec4d8a3b0e710919fe.png",
  },
  {
    shopName: "Powerhouse Vita C Plus",
    price: 110,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65cb4792bb3d5266771e9369",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65caa6970ac0a2404e4e082a.png",
  },
  {
    shopName: "Pumice Scrub",
    price: 60,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65caa9ec81ca7959aaee6e86",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65caa69797fb7b6c231bd797.png",
  },
  {
    shopName: "Pumpkin Renewal Mask",
    price: 70,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/pumpkinrenewalmask",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65caa69797fb7ba5091bd798.png",
  },
  {
    shopName: "Secret Glow",
    price: 120,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9de0e1ea4349c561d77f",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35530a00c2121f7a83.webp",
  },
  {
    shopName: "Secret Gold 24k Gold Mask",
    price: 140,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9ecde1ea43765161d7b4",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8e9fc5844bff.webp",
  },
  {
    shopName: "Secret Pearl",
    price: 180,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9e240e82043b1ba2cd67",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8e4c93844c01.webp",
  },
  {
    shopName: "Secret Radiance",
    price: 120,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9e5be1ea435cf461d7a1",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35b1b53279a27aa3a7.webp",
  },
  {
    shopName: "Shampoo Bundle",
    price: 50,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b8669e1ea436e2561cdc1",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8e1a84844bfe.webp",
  },
  {
    shopName: "Silky Smooth + (Retinol + Bakuchiol Serum)",
    price: 140,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65cb47de18faaafa1536b974",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65caa69743c7e99bc03e3821.png",
  },
  {
    shopName: "Skin Vitalizing Cleanser",
    price: 34,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65cb433418faaa857036b893",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65cb4455664faf2facf0e59a.png",
  },
  {
    shopName: "Skin Vitalizing Toner",
    price: 34,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65cb44dabb3d5247b81e92eb",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65cb449c8675771a4b0cba06.png",
  },
  {
    shopName: "Spot Eraser",
    price: 160,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b8548e1ea43078961cd49",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8e70f8844c02.webp",
  },
  {
    shopName: "Sulfur Mask",
    price: 70,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/6632aae38f23265e91794c67",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/6632aabe2807116f05f792da.png",
  },
  {
    shopName: "The Secret Collection",
    price: 560,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9c180e8204429ea2cc30",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35c9fed2a40dec6879.webp",
  },
  {
    shopName: "Ultimate Glow Collection",
    price: 920,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666ba0250e8204ddb9a2cdd7",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b9ffbe7c44d194122f4af.webp",
  },
  {
    shopName: "Underarm Brightener",
    price: 95,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b84f30e82046e99a2c23f",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8edd00844c04.webp",
  },
  {
    shopName: "UV Protect SPF 44 Tint + Hyaluronic Acid",
    price: 70,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/65cb476618faaa603636b959",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/65cb485f86757738740cbf53.png",
  },
  {
    shopName: "Vitamin C",
    price: 120,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9d5ce1ea43d07e61d70e",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f3581bb8e43f1844c03.webp",
  },
  {
    shopName: "Wrinkle Eye",
    price: 120,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/666b9f02e1ea4327b061d7bf",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/666b5f35f3c7253eae5a486d.webp",
  },
  {
    shopName: "Zinc UV Defense",
    price: 65,
    productUrl:
      "https://www.gravitasmedspa.com/product-details/product/6632ae6e8f23264834794e59",
    imageUrl:
      "https://storage.googleapis.com/msgsndr/Spxjqyjo4PugapxDk6S6/media/6632ae4837a2465324bc8554.png",
  },
];

export function isGravitasMedspaShopUrl(url: string | undefined | null): boolean {
  const trimmed = url?.trim();
  if (!trimmed) return false;
  try {
    return new URL(trimmed).hostname.includes("gravitasmedspa.com");
  } catch {
    return false;
  }
}

function normalizeShopName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/** Internal catalog names → shop listing title (when they differ). */
const GRAVITAS_CATALOG_TO_SHOP_NAME: Record<string, string> = {
  "Acne Erase Cream": "Acne Erase",
  "BHA Exfoliating Essence 2% Salicylic Acid + Niacinamide Solution":
    "Secret Pearl",
  "Body BB Glow Brightening Cream": "Body BB Glow",
  "Broad Spectrum SPF 50": "Broad Spectrum Sunscreen",
  "Clarifying Shampoo": "Healthy Hair Shampoo",
  "Freshlook Eye Repair Cream": "Fresh Look Eye Repair Cream",
  "Millk Brightening Body Bar": "Milk Brigthening Bar",
  "Olivia No. 1 Eau De Parfum": "OLIVIA NO.1 EAU DE PARFUM",
  "Powerhouse Vit. C Plus": "Powerhouse Vita C Plus",
  "Secret Gold Overnight Mask": "Secret Gold 24k Gold Mask",
  "Secret Glow Overnight Mask": "Secret Glow",
  "Silky Smooth Plus (Retinol w/ Bakuchiol Serum)":
    "Silky Smooth + (Retinol + Bakuchiol Serum)",
  "Cell Repair w/ Growth Factor": "Cell Repair (Growth Factor)",
  "Ultimate Glow Regimen": "Ultimate Glow Collection",
  "UV Protect SPF 44 w/ Tint and Hyaluronic Acid":
    "UV Protect SPF 44 Tint + Hyaluronic Acid",
  "Vitamin C Serum 20%": "Vitamin C",
};

/** Legacy Olivia Quido line items still on the Gravitas shop — excluded from the app catalog. */
const GRAVITAS_EXCLUDED_SHOP_PRODUCT_NAMES = new Set(
  [
    "Active Moisturizer",
    "Balancing Toner",
    "Beauty oil",
    "Beauty Queen Skincare Kit",
    "Body BB Glow",
    "Cleansing Milk",
    "Daily Essentials Regimen",
    "Healthy Hair Conditioner",
    "Healthy Hair Shampoo",
    "Milk Brigthening Bar",
    "OLIVIA NO.1 EAU DE PARFUM",
    "Secret Glow",
    "Secret Gold 24k Gold Mask",
    "Secret Pearl",
    "Secret Radiance",
    "The Secret Collection",
    "Ultimate Glow Collection",
    "Vitamin C",
    "Wrinkle Eye",
  ].map(normalizeShopName),
);

const shopByNormalizedName = new Map<string, GravitasShopListing>();
for (const listing of GRAVITAS_SHOP_LISTINGS) {
  shopByNormalizedName.set(normalizeShopName(listing.shopName), listing);
}

export function isExcludedGravitasShopProduct(shopName: string): boolean {
  return GRAVITAS_EXCLUDED_SHOP_PRODUCT_NAMES.has(normalizeShopName(shopName));
}

export function getGravitasShopListingForCatalogProduct(
  catalogName: string,
): GravitasShopListing | undefined {
  const key = catalogName.trim();
  if (!key) return undefined;
  const shopName = GRAVITAS_CATALOG_TO_SHOP_NAME[key] ?? key;
  return (
    shopByNormalizedName.get(normalizeShopName(shopName)) ??
    shopByNormalizedName.get(normalizeShopName(key))
  );
}

/** Shop-only SKUs not in the internal pricing catalog (kits, bundles, etc.). */
export function getGravitasShopOnlyCarouselItems(
  matchedCatalogProductNames: readonly string[],
): {
  name: string;
  imageUrl: string;
  productUrl: string;
  price: string;
  description: string;
}[] {
  const matchedShopNorms = new Set<string>();
  for (const catalogName of matchedCatalogProductNames) {
    const listing = getGravitasShopListingForCatalogProduct(catalogName);
    if (listing) matchedShopNorms.add(normalizeShopName(listing.shopName));
  }

  return GRAVITAS_SHOP_LISTINGS.filter((listing) => {
    const norm = normalizeShopName(listing.shopName);
    if (GRAVITAS_EXCLUDED_SHOP_PRODUCT_NAMES.has(norm)) return false;
    if (matchedShopNorms.has(norm)) return false;
    // Second duplicate Acne Cream listing on the shop (same SKU, different product id).
    if (
      norm === "acne cream" &&
      listing.productUrl.includes("666b90c30e820420f0a2c8b5")
    ) {
      return false;
    }
    return true;
  }).map((listing) => ({
    name: listing.shopName,
    imageUrl: listing.imageUrl,
    productUrl: listing.productUrl,
    price: `$${listing.price}`,
    description: "Available at Gravitas Medspa",
  }));
}
